// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"19b7f0b4","557":"2c5db5ef","787":"e72a8928"}[chunkId] + ".chunk.js";
};